module.exports = __webpack_public_path__ + "img/运动小秘详情页_01.b8e041f7.jpg";